import { toZonedTime, format, fromZonedTime } from 'date-fns-tz';
const timeZone = 'Europe/Oslo';

export function ToLocalDate(date: Date, dateFormat?: string) {
    if (!date) return '';

    const zonedDate = toZonedTime(date, timeZone);

    switch (dateFormat) {
        case 'ISOdate':
            return FormatDateISO(zonedDate);
        case 'time':
            return FormatTime(zonedDate);
        case 'date':
            return FormatDate(zonedDate);
        default:
            return FormatDateTime(zonedDate);
    }
}

export function FormatDateTime(date: Date) {
    return format(date, 'dd.MM.yyyy HH:mm');
}

export function FormatDateISO(date: Date) {
    return format(date, 'yyyy-MM-dd');
}

function FormatDate(date: Date) {
    return format(date, 'yyyy.MM.dd');
}

function FormatTime(date: Date) {
    return format(date, 'HH:mm');
}

export function DateToUTC(date: string, time: string) {
    return fromZonedTime(date + ' ' + time, timeZone);
}

export function FormatDateToUTC(date: Date | string) {
    return fromZonedTime(date, timeZone);
}
